import { render, staticRenderFns } from "./reconcile.vue?vue&type=template&id=2b47899c&"
import script from "./reconcile.vue?vue&type=script&lang=js&"
export * from "./reconcile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports